import { NgClass, NgStyle } from '@angular/common';
import { Component, input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass, NgStyle],
})
export class LoaderComponent {
    readonly fullPage = input(true);
    readonly size = input('100px');
    readonly strokeWidth = input('28%');
    readonly showBackgroundCircle = input(true);
    readonly visible = input.required<boolean>();
}
